import KeenSlider from 'keen-slider'
/**
 * 指定時間後にpromiseを返す
 *
 * @param {int} ms
 */
function sleep (ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve()
    }, ms)
  })
}
const eventPreventDefault = e => {
  e.preventDefault()
}
const scrollbarPosition = (bar, item, content) => {
  bar.style.display = content.scrollHeight - content.clientHeight === 0 ? 'none' : 'block'
  content.addEventListener('scroll', e => {
    const target = e.currentTarget
    const maxScrollTop = target.scrollHeight - target.clientHeight
    const scrollTop = target.scrollTop
    const scrollRatio = scrollTop / maxScrollTop
    const scrollbarDiff = bar.clientHeight - item.clientHeight
    item.style.transform = 'translate3d(0,' + scrollbarDiff * scrollRatio + 'px,0)'
  }, { passive: true })
}
window.addEventListener('DOMContentLoaded', () => {
  const blogBody = S('.jsBlogBody')
  const postBody = S('.jsPostBody')
  if (blogBody || postBody) {
    const mainBoard = S('.jsMainBoard')
    mainBoard.classList.add('header-board__main-board--visible')
    const buttonBoard = S('.jsButtonBoard')
    buttonBoard.classList.add('header-board__button-board--visible')
    const navBoard = S('.jsNavBoard')
    const headerBoardCover = S('.jsHeaderBoardCover')

    let navClickFlag = false
    const buttonBoardClick = e => {
      if (navClickFlag) return
      navClickFlag = true
      const navBoolean = navBoard.classList.toggle('header-board__nav-board--visible')

      if (navBoolean) {
        headerNavObserver.observe(mainBoard)
        headerBoardCover.classList.add('header-board__cover--on')
        headerBoardCover.classList.remove('header-board__cover--off')
        sleep(200)
          .then(() => {
            buttonBoard.classList.remove('header-board__button-board--visible')

            return sleep(600)
          })
          .then(() => {
            buttonBoard.classList.add('header-board__button-board--visible')
            buttonBoard.classList.add('header-board__button-board--on')
            return sleep(200)
          })
          .then(() => {
            navClickFlag = false
          })
      } else {
        headerNavObserver.unobserve(mainBoard)
        headerBoardCover.classList.remove('header-board__cover--on')
        headerBoardCover.classList.add('header-board__cover--off')

        buttonBoard.classList.remove('header-board__button-board--visible')
        mainBoard.classList.remove('header-board__main-board--fixed')
        sleep(500)
          .then(() => {
            mainBoard.classList.add('header-board__main-board--visible')
            buttonBoard.classList.add('header-board__button-board--visible')
            buttonBoard.classList.remove('header-board__button-board--on')
            navClickFlag = false
          })
      }
    }
    buttonBoard.addEventListener('click', buttonBoardClick)
    headerBoardCover.addEventListener('click', buttonBoardClick)
    let lastInnerWidth = window.innerWidth; let resizeHeaderFlag = false
    const resizeHeaderChange = () => {
      if (resizeHeaderFlag) return
      resizeHeaderFlag = true
      const tmpInnerWidth = window.innerWidth
      if (lastInnerWidth === tmpInnerWidth) return
      lastInnerWidth = tmpInnerWidth
      mainBoard.classList.remove('header-board__main-board--visible')
      buttonBoard.classList.remove('header-board__button-board--visible')
      navBoard.classList.remove('header-board__nav-board--visible')

      sleep(400)
        .then(() => {
          buttonBoard.classList.remove('header-board__button-board--on')
          mainBoard.classList.add('header-board__main-board--visible')
          buttonBoard.classList.add('header-board__button-board--visible')
          return sleep(1000)
        })
        .then(() => {
          resizeHeaderFlag = false
        })
    }
    window.addEventListener('resize', resizeHeaderChange, { passive: true })

    const headerNavObserveOpt = {
      rootMargin: '-12% 0px 0px'
    }
    const headerNavObserveCall = e => {
      if (!e[0].isIntersecting) {
        mainBoard.classList.remove('header-board__main-board--visible')
        sleep(500)
          .then(() => {
            mainBoard.classList.add('header-board__main-board--fixed')
          })
      }
    }
    const headerNavObserver = new IntersectionObserver(headerNavObserveCall, headerNavObserveOpt)

    const searchScrollbar = S('.jsSearchScrollbar')
    const searchScrollItem = S('.jsSearchScrollItem')

    const searchLists = S('.jsSearchLists')

    const headerSearchInput = S('.jsHeaderSearchInput')
    const headerSearchButton = S('.jsHeaderSearchButton')
    const searchJump = e => {
      window.location.href = homeUrl + '/articles/' + postType + '?zS=' + headerSearchInput.value
    }
    headerSearchButton.addEventListener('click', searchJump)

    headerSearchInput.addEventListener('keyup', e => {
      if (e.key === 'Enter') { searchJump() }
    })

    const setScroll = () => {
      if (window.innerWidth <= 640) return
      const scrollRatio = searchLists.clientHeight / searchLists.scrollHeight
      searchScrollbar.style.display = scrollRatio >= 1 ? 'none' : 'block'
    }
    setScroll()
    window.addEventListener('resize', setScroll, { passive: true })

    searchLists.addEventListener('scroll', e => {
      const maxScrollTop = searchLists.scrollHeight - searchLists.clientHeight
      const scrollTop = e.target.scrollTop
      const scrollRatio = scrollTop / maxScrollTop

      const scrollbarDiff = searchScrollbar.clientHeight - searchScrollItem.clientHeight
      searchScrollItem.style.transform = 'translate3d(0,' + scrollbarDiff * scrollRatio + 'px,0)'
    }, { passive: true })

    const bodyWrapper = S('.jsBodyWrapper')
    const searchNav = S('.jsSearchNav')
    const bodyContent = S('.jsBodyContent')
    const bodyWrapperToggle = () => {
      searchNav.style.transition = '.4s transform'
      searchNav.style.willChange = 'tranform'
      bodyContent.style.transition = '.4s transform'
      bodyContent.style.willChange = 'tranform'
      const toggleBoolean = bodyWrapper.classList.toggle('body-wrapper--open')
      if (toggleBoolean) {
        bodyWrapper.style.height = '100vh'
        const toggleBoolean = bodyWrapper.classList.remove('body-wrapper--close')
      } else {
        bodyWrapper.style.height = ''
        const toggleBoolean = bodyWrapper.classList.add('body-wrapper--close')
      }
      sleep(400)
        .then(() => {
          searchNav.style.transition = ''
          searchNav.style.willChange = ''
          bodyContent.style.transition = ''
          bodyContent.style.willChange = ''
        })
    }
    S('.jsNavSearch').addEventListener('click', bodyWrapperToggle)
    S('.jsSearchBack').addEventListener('click', bodyWrapperToggle)
    S('.jsBodyCover').addEventListener('click', bodyWrapperToggle)

    const rankingList = S('.jsRandomList')
    if (rankingList) {
      let current; let timeout; let mouseOver = false; let timerTimeout; let timerCount = 0; let styleCangePie
      const buttonBefore = S('.jsRandomBefore')
      const buttonAfter = S('.jsRandomAfter')
      const randomDescription = S('.jsRandomDescription')
      const randomPlugin = slider => {
        buttonBefore.onclick = () => slider.prev()
        buttonAfter.onclick = () => slider.next()
        slider.on('created', () => {
          current = slider.track.details.rel
          randomDescription[current].classList.add('top-random__description-item--current')
        })
        slider.on('slideChanged', () => {
          randomDescription[current].classList.remove('top-random__description-item--current')
          current = slider.track.details.rel
          randomDescription[current].classList.add('top-random__description-item--current')
        })
        const clearTimerTimeout = () => {
          timerCount = 0
          styleCangePie = timerPie.dataset.on === '0' ? timerPie : timerPieCover
          styleCangePie.style.strokeDasharray = timerCount + ',157,0,' + (157 - timerCount)
          clearTimeout(timerTimeout)
        }
        const topRandomTimerSvg = S('.jsTopRandomTimerSVG')
        const changeTimer = () => {
          timerCount = 0
          clearTimeout(timerTimeout)
          styleCangePie = timerPie.dataset.on === '0' ? [[timerPie, topRandomTimerSvg[0]], [timerPieCover, topRandomTimerSvg[1]]] : [[timerPieCover, topRandomTimerSvg[1]], [timerPie, topRandomTimerSvg[0]]]

          styleCangePie[1][0].style.transitionDuration = '0s'
          styleCangePie[1][0].style.strokeDasharray = '0,157,0,157'
          styleCangePie[0][1].style.zIndex = '0'
          styleCangePie[1][1].style.zIndex = '1'
          styleCangePie[1][0].style.strokeDasharray = ''
          sleep(50)
            .then(() => {
              styleCangePie[1][0].style.transitionDuration = ''
            })
        }
        const timerPie = S('.jsTopRandomTimer')
        const timerPieCover = S('.jsTopRandomTimerCover')
        timerPie.dataset.on = '0'
        const timerAnimation = () => {
          clearTimeout(timerTimeout)
          if (timerCount > 157) return
          styleCangePie = timerPie.dataset.on === '0' ? timerPie : timerPieCover
          styleCangePie.style.strokeDasharray = timerCount + ',157,0,' + (157 - timerCount)
          timerCount++
          timerTimeout = setTimeout(timerAnimation, 5000 / 157)
        }
        const clearNextTimeout = () => {
          clearTimeout(timeout)
        }
        const nextTimeout = () => {
          clearTimeout(timeout)
          if (mouseOver) return
          timerAnimation()
          timeout = setTimeout(() => {
            changeTimer()
            timerPie.dataset.on = timerPie.dataset.on === '0' ? '1' : '0'
            slider.next()
          }, 5500)
        }
        slider.on('created', () => {
          const parentRandom = S('.top-random')
          parentRandom.addEventListener('mouseover', () => {
            mouseOver = true
            clearNextTimeout()
            clearTimerTimeout()
          })
          parentRandom.addEventListener('mouseout', () => {
            mouseOver = false
            nextTimeout()
          })
          nextTimeout()
        })
        slider.on('dragStarted', () => {
          clearNextTimeout()
          clearTimerTimeout()
        })
        slider.on('animationEnded', nextTimeout)
        window.addEventListener('focus', function(){
          nextTimeout()
        })
        window.addEventListener('blur', function(){
          clearNextTimeout()
          clearTimerTimeout()
        })
      }

      const randomSlider = new KeenSlider(
        '.jsRandomList',
        {
          loop: true,
          slides: {
            origin: 'center',
            perView: 'auto',
            spacing: 0
          },
          vertical: true,
          breakpoints: {
            '(max-width: 768px)': {
              vertical: false
            }
          }
        },
        [randomPlugin]
      )
    };

    const blogFooter = S('.footer-blog')

    const footerTitle = blogFooter.querySelectorAll('.jsFooterTitle')
    const footerLists = blogFooter.querySelectorAll('.jsFooterLists')
    footerTitle.forEach((title, i) => {
      title.onclick = e => {
        e.currentTarget.classList.toggle('footer-blog__title--open')
        footerLists[i].classList.toggle('footer-blog__lists--open')
      }
    })

    const homeCategoryMore = S('.jsHomeCategoryMore')
    if (homeCategoryMore) {
      homeCategoryMore.addEventListener('click', e => {
        const openBoolean = e.currentTarget.querySelector('.category-lists__category-more-svg').classList.toggle('category-lists__category-more-svg--open')
        S('.jsHomeCategoryLists').classList.toggle('category-lists--open')
        e.currentTarget.querySelector('.category-lists__category-more-text').innerText = openBoolean ? '表示しない' : 'もっと表示する'
      })
    }
  }
  const blogArticles = S('.jsArticles')
  if (blogArticles) {
    const articlesButton = S('.jsArticlesButton')
    articlesButton.addEventListener('click', e => {
      const animationFlag = blogArticles.classList.toggle('articles-customize--on')
      const articlesButtonText = blogArticles.querySelector('.articles-customize__button-text')
    })

    const articlesScrollbar = S('.articles-customize__scroll')
    const articlesScrollItem = S('.articles-customize__scroll-item')

    const articlesScrollContent = S('.jsArticlesScrollContent')
    scrollbarPosition(articlesScrollbar, articlesScrollItem, articlesScrollContent)

    let lastInnerWidth = 0
    window.addEventListener('resize', e => {
      const tmpInnerWidth = window.innerWidth
      if (lastInnerWidth !== tmpInnerWidth) {
        lastInnerWidth = tmpInnerWidth
      } else {
        return
      }
      articlesScrollbar.style.display = articlesScrollContent.scrollHeight - articlesScrollContent.clientHeight === 0 ? 'none' : 'block'
    }, { passive: true })
  }
  /**
    * smooth scroll function for link of table of contents.
    */
  const ancLinks = S( 'a[href^="#"]', true )
  const ancLinksArrary = Array.prototype.slice.call( ancLinks )
  if(ancLinks.length > 0)
  {
    ancLinksArrary.forEach( link => {
      link.addEventListener( 'click', e => {
        e.preventDefault()
        const targetId = link.hash
        const targetEl = S( targetId )

        const targetOffset = window.pageYOffset + targetEl.getBoundingClientRect().top
        window.scrollTo( {
          top: targetOffset,
          behavior: "smooth",
        } )
      } )
    } )
  }
  /**
   * Scroll to the Page top
   */
  ( function () {
    const bodyEl = S( 'body' )
    const pageTopWrapper = document.createElement( 'div' )
    pageTopWrapper.classList.add( 'pagetop-button' )
    const pageTopMain = document.createElement( 'div' )
    pageTopMain.classList.add( 'pagetop-button__content' )
    pageTopMain.innerHTML = '<svg class="pagetop-button__img" xmlns="http://www.w3.org/2000/svg" width="22.828" height="26" viewBox="0 0 22.828 26"><path d="M-4330.6-4953.563v24" transform="translate(4342.012 4954.563)" fill="none" stroke="#333" stroke-linecap="round" stroke-width="2"/><path d="M-4330.6-4953.563l10,10-10,10" transform="translate(4954.978 -4319.598) rotate(-90)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>'

    pageTopMain.addEventListener( 'click', e => {
      window.scrollTo( {
        top: 0,
        behavior: "smooth",
      } )
    })

    bodyEl.appendChild( pageTopWrapper )
    pageTopWrapper.appendChild( pageTopMain )
    const turnHeight = document.documentElement.clientHeight || document.body.clientHeight
    window.addEventListener( 'scroll', () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if( scrollTop > turnHeight ){
        pageTopMain.classList.add( 'pagetop-button__content--show' )
      } else {
        pageTopMain.classList.remove( 'pagetop-button__content--show' )
      }
    }, { passive: true } )
  } () )
})
